import classNames from 'classnames';
import React from 'react';

import Button from 'sharedreact/components/Button';

type SegmentType = {
  id: string,
  icon?: string,
  text?: string,
  tooltip?: string
};

type Props = {
  id: string,
  className?: string,
  segmentClassName?: string,
  disabled?: boolean,
  stretch?: boolean,
  segments: SegmentType[],
  selectedId?: string,
  children?: React.ReactNode,
  onClick?: (segmentId: string, event?: React.MouseEvent<HTMLButtonElement>) => void
};

class SegmentedButton extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, className, segmentClassName, disabled, stretch, segments,
      selectedId, children, onClick } = this.props;

    const renderedSegments = segments.map((segment) => {
      const onSegmentClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick) {
          onClick(segment.id, event);
        }
      };
      if (stretch) {
        return (
          <div key={segment.id} className='esko_btn-group' role='group'>
            <Button id={id + '_' + segment.id}
              type='btn-default'
              className={segmentClassName}
              icon={segment.icon}
              disabled={disabled}
              onClick={onSegmentClick}
              active={selectedId != null && selectedId === segment.id}
              title={segment.tooltip}
            >
              {segment.text}
            </Button>
          </div>
        );
      } else {
        return (
          <Button id={id + '_' + segment.id}
            type='btn-default'
            key={segment.id}
            className={segmentClassName}
            icon={segment.icon}
            disabled={disabled}
            onClick={onSegmentClick}
            active={selectedId === segment.id}
            title={segment.tooltip}
          >
            {segment.text}
          </Button>
        );
      }
    });

    return (
      <div
        className={classNames(
          'esko_btn-group',
          className,
          {'esko_btn-group-justified': stretch}
        )}
        role='group'
      >
        {renderedSegments}
        {children}
      </div>
    );
  }
}

export type { SegmentType };

export default SegmentedButton;
